import { render } from "./SearchForm.vue?vue&type=template&id=6977dbb8&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=ts"
export * from "./SearchForm.vue?vue&type=script&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=6977dbb8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6977dbb8"

export default script